const React = require('react');
const isNode = (typeof process !== 'undefined');
const {Collapse} = isNode ? require('react-collapse') : () => null;
const presets = isNode ? require('react-motion') : () => {};
const Forms = require('./../../Forms');

class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
    }

    render() {
        const {emailServiceUrl, hideContactForms, termsPageUrl, formSubmitSuccessPageUrl} = this.props;
        const {open} = this.state;
        return (
        <footer className="footer">
            {!hideContactForms && (
            <div className="footer__contact">
                <h3 className="footer__header" onClick={() => this.setState({open: !this.state.open})}>
                    Kontaktskjema
                    <svg className={'footer__arrow' + (open ? ' footer__arrow--open' : '')} x="0px" y="0px" viewBox="0 0 960 560">
                        <g>
                            <path d="M480,344.181L268.869,131.889c-15.756-15.859-41.3-15.859-57.054,0c-15.754,15.857-15.754,41.57,0,57.431l237.632,238.937
                                        c8.395,8.451,19.562,12.254,30.553,11.698c10.993,0.556,22.159-3.247,30.555-11.698l237.631-238.937
                                        c15.756-15.86,15.756-41.571,0-57.431s-41.299-15.859-57.051,0L480,344.181z"/>
                        </g>
                    </svg>
                </h3>
                {isNode && (
                <Collapse isOpened={open} springConfig={presets.stiff}>
                    <div className="footer__forms">
                        <div className="forms">
                            <div className="forms__container">
                                <Forms emailServiceUrl={emailServiceUrl} termsPageUrl={termsPageUrl} formSubmitSuccessPageUrl={formSubmitSuccessPageUrl} />
                            </div>
                        </div>
                    </div>
                </Collapse>
                )}
            </div>
            )}
            <div className="footer__social">
                <div className="footer__icons">
                    <a className="some-link" href="https://www.facebook.com/Maya-Eiendom-As-425843390784018/">
                        <svg viewBox="0 0 50 50" x="0" y="0">
                            <path d="M26 20v-3c0-1.3.3-2 2.4-2H31v-5h-4c-5 0-7 3.3-7 7v3h-4v5h4v15h6V25h4.4l.6-5h-5z"/>
                        </svg>
                    </a>
                    <a className="some-link" href="https://www.instagram.com/mayaeiendom/">
                        <svg width="24" height="24" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
                    </a>
                    <a className="some-link" href="https://www.linkedin.com/company/inka-entrepren%C3%B8r-as/">
                        <svg width="24" height="24" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg>
                    </a>
                </div>
                <div className="footer__information">
                    <p>
                        Brynsveien 16 | 0667 Oslo
                    </p>
                    <a href="mailto:post@maya.no">post@maya.no</a>
                    <a href="tel:22992850">22992850</a>
                </div>
            </div>
        </footer>
        )
    }
}

module.exports = Footer;



// WEBPACK FOOTER //
// ./src/main/resources/site/parts/footer/Component/index.jsx